import React from "react";

function Footer() {
  return (
    <div className='text-gray-900 absolute bottom-0 pb-3 sm:text-lg md:text-xl'>
      <a
        href='https://www.buymeacoffee.com/2spacemilk'
        className='link-border'
        target='_blank'
        rel='noopener noreferrer'
        alt='Buy Me A Coffee'>
        Buy me a coffee
      </a>
    </div>
  );
}

export default Footer;
